<template>
  <div
    class="diaLog_box_coverCloth"
    ref="diaLog_box_coverCloth"
    @touchmove.prevent
    @mousewheel.prevent
  >
    <div class="diaLog_box">
      <div class="dialoig_title">
        <span>{{ this.$t('lang.external.personal.head.更换头像') }}</span>
        <div class="closeBox">
          <img
            :src="serverURL + 'images/dialog_close_icon.png'"
            alt=""
            width="17.1px"
            height="17.1px"
            class="dialogClose_icon"
            @click="close_dialog"
          />
        </div>
      </div>
      <div class="dialog_content">
        <div>
          <img
            :src="userInfo.photo || serverURL + 'images/pig.jpg'"
            ref="personal_img"
          />
        </div>
      </div>
      <div class="dialog_buttons">
        <button class="upload_img" @click="choiceImg" type="primary">
          {{ this.$t('lang.external.personal.head.上传图片') }}
        </button>
        <input
          ref="filElem"
          type="file"
          class="upload-file"
          @change="getFile"
        />
        <button class="update_img" @click="update_img">
          {{ this.$t('lang.external.personal.head.确认修改') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { uploadImg } from '@/api/personalCenter/index'
import { modifyInfo } from '@/api/personalCenter/index'
export default {
  name: '',
  components: {},
  props: ['scorllTopVaule'],
  data() {
    return {
      topValue: 0,
      imgUrl: '',
      inputFile: '',
    }
  },
  watch: {},
  computed: {
    ...mapState(['userInfo']),
    serverURL() {
      return this.publicData.serverUrl
    },
  },
  created() {},
  mounted() {
    // 去除底部部分空白
    this.topValue = this.scorllTopVaule
    if (this.scorllTopVaule != 0) {
      this.topValue =
        this.scorllTopVaule +
        (this.scorllTopVaule - this.scorllTopVaule * 0.885)
    }
    this.firstChange = true
  },
  methods: {
    errorHandler() {
      return true
    },
    close_dialog() {
      this.$emit('closeDialog', false)
    },
    choiceImg() {
      this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
    },
    getFile() {
      var that = this
      var inputFile = this.$refs.filElem.files[0]
      if (inputFile) {
        if (
          inputFile.type !== 'image/jpeg' &&
          inputFile.type !== 'image/png' &&
          inputFile.type !== 'image/gif'
        ) {
          this.$message({
            showClose: true,
            message: '不是有效的图片文件！',
            type: 'error',
            customClass: 'dialog_error_message',
            duration: 2000,
          })
          return
        }
        this.inputFile = inputFile
        const reader = new FileReader()
        reader.readAsDataURL(inputFile)
        reader.onload = function (e) {
          that.$refs.personal_img.src = this.result
        }
      } else {
        return
      }
    },
    //修改头像
    update_img() {
      var params = new FormData()
      params.append('file', this.inputFile)
      if (params.get('file') === '' || params.get('file') === undefined) {
        return
      }
      uploadImg(params).then((res) => {
        const { data } = res
        var param = new FormData()
        param.append('photo', data.path)
        modifyInfo(param).then((res) => {
          this.$router.go(0)
        })
      })
    },
    // 将base64转换成file对象
    dataURLtoFile(dataurl, filename = 'file') {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, { type: mime })
    },
  },
  created() {},
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
.diaLog_box_coverCloth {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
}
.diaLog_box {
  width: 300px;
  height: 300px;
  background-color: #fff;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  border-radius: 5px;
}
.closeBox {
  width: 40px;
}
.dialoig_title {
  width: 100%;
  height: 45px;
  background-color: #edf2f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.dialoig_title span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #666666;
  line-height: 18px;
  margin-left: 5%;
}
.dialogClose_icon {
  cursor: pointer;
  margin-left: 10px;
}
.headPortrait_dialog {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 3%;
  margin: auto;
}
.dialog_buttons {
  position: absolute;
  bottom: 7%;
  left: 12%;
}
.dialog_buttons .upload_img {
  width: 100px;
  height: 35px;
  background-color: #0c5893;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-family: Microsoft YaHei;
  cursor: pointer;
}
.dialog_buttons .update_img {
  width: 100px;
  height: 35px;
  border: 1px solid #0c5893;
  background-color: #fff;
  color: #0c5893;
  border-radius: 5px;
  font-family: Microsoft YaHei;
  margin-left: 25px;
  cursor: pointer;
}
.upload-file {
  display: none;
}
.dialog_error_message {
  z-index: 100 !important;
}
.el-avatar > img {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-bottom: 1rem;
}
.dialog_content {
  display: flex;
  height: 200px;
  justify-content: center;

  align-items: center;
}
.dialog_content img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}
</style>